import { render, staticRenderFns } from "./NewEditor.vue?vue&type=template&id=7afc1e6e"
import script from "./NewEditor.vue?vue&type=script&lang=js"
export * from "./NewEditor.vue?vue&type=script&lang=js"
import style0 from "./NewEditor.vue?vue&type=style&index=0&id=7afc1e6e&prod&lang=css"
import style1 from "./NewEditor.vue?vue&type=style&index=1&id=7afc1e6e&prod&lang=css"
import style2 from "./NewEditor.vue?vue&type=style&index=2&id=7afc1e6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports